import React from 'react';
import '../../style/style.css';
import AiAvatar from '../../../../assets/img/capitaoRocha.jpeg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import SidebarItem from './components/sidebarItem';

// Os ícones podem ser do bootstrap-icons, font-awesome, ou SVGs customizados.
// Por simplicidade, usaremos texto.
library.add(fas);

const Sidebar = ({ aiModel, handleChangeAiModel, frontConfigs }) => {
    return (
        <div className="sidebar">
            <div className='page-title'>

                <img
                    src={AiAvatar}
                    alt="Avatar da IA"
                    // Apenas altere os valores de width e height aqui
                    style={{ width: '45px', height: '45px', marginRight: '10px', borderRadius: '50%', verticalAlign: 'middle' }}
                />
                <h2>Capitão Rocha</h2>
            </div>
            <ul className="nav flex-column">
                {frontConfigs.map((item) => (
                    <SidebarItem
                        key={item.assistantId} // Adicione uma `key` única para ajudar o React
                        aiIconConfig={item.frontIcon}
                        aiLabelConfig={item.frontLabel} // estava usando "aiLabelConfig", mas o valor vem de "frontLabel"
                        aiModel={aiModel}
                        aiModelConfig={item.assistantId}
                        handleChangeAiModel={handleChangeAiModel}
                    />
                ))}


                {/* Adicione os outros botões da mesma forma */}
            </ul>
        </div>
    );
};

export default Sidebar;